// extracted by mini-css-extract-plugin
module.exports = {"userButton":"SignUpSignInButton_userButton__6STJg","custom":"SignUpSignInButton_custom__QCtLB","buttons":"SignUpSignInButton_buttons__a__90"};